<div class="row" style="margin-bottom:15px;">
  <div class="col-md-4">
    <input type="file" #file accept="image/jpg, image/png, image/jpeg, video/mp4" placeholder="Choose file"
      (change)="uploadFile(file.files)" style="display:none;" multiple>
    <button type="button" class="btn btn-milliyet" (click)="file.click()">Dosyalara
      Gözat</button>
  </div>
  <div class="col-md-8">
    <span class="upload" *ngIf="progress> 0">
      {{progress}}%
    </span>
    <span class="{{type}}" *ngIf="message">
      {{message}}
    </span>
  </div>
</div>